import type { Locale } from '@fixter/i18n';
import config from 'config';
import { CmsContentfulTypename } from '$cms/contentful.types';

const QUERY_FETCH_SYMPTOMS_PAGE_COLLECTION = `
  query FetchSymptomsPageCollection($preview: Boolean, $locale: String!) {
    symptomPageCollectionCmsData: pageCollection(preview: $preview, locale: $locale, where: { pageGroup: { key_in: ["symptom"] }}) {
      items {
        __typename
        urlPath
        slug
        pageGroupCollection(limit: 5) {
          items {
            __typename
            name
          }
        }
        configuration {
          id
          uiComponent
          __typename
          translatedEntitiesCollection {
            items {
              ... on ${CmsContentfulTypename.shortText} {
                __typename
                key
                value
              }
              ... on ${CmsContentfulTypename.richText} {
                __typename
                key
                content: value {
                  json
                }
              }
              ... on ${CmsContentfulTypename.image} {
                __typename
                key
                img: value
                title
                alt
              }
            }
          }
        }
      }
    }
  }
`;

export async function fetchSymptomPageCollectionData({
  locale,
  preview,
}: {
  readonly locale: Locale;
  readonly preview?: boolean;
}) {
  const res = await fetch(
    `https://graphql.contentful.com/content/v1/spaces/${config.get(
      'contentful.spaceId'
    )}/environments/master`,
    {
      method: 'POST',
      headers: {
        /**
         * @note the production access token doesn't work with `preview: true`
         */
        Authorization: `Bearer ${config.get('contentful.accessToken')}`,
        'content-type': 'application/json',
      },
      body: JSON.stringify({
        query: QUERY_FETCH_SYMPTOMS_PAGE_COLLECTION,
        variables: {
          locale,
          preview,
        },
      }),
    }
  );

  if (!res.ok) {
    throw new Error(`Contentful component request failed: ${res.status} ${res.statusText}`);
  }

  const { data } = await res.json();

  return data;
}
